module.exports = __webpack_public_path__ + "img/All Dogs Go To Heaven.98a511af.jpg";